import * as XLSX from "xlsx";
import { ALL_TERMINALS_VALUE, flattenReportTransactions } from "./TransactionSearchReport.utils";
import { formatUtcToLocal, getLocalTzLabel } from "../../../services/dateUtils";

const tzLabel = getLocalTzLabel();
const withTz = (label) => (tzLabel ? `${label} (${tzLabel})` : label);

const formatDateTime = (value) =>
  formatUtcToLocal(value, { second: "2-digit" }) || "N/A";

export function buildTransactionSearchExportRows(responseData, terminalFilter) {
  const transactions = flattenReportTransactions(responseData);
  const scoped =
    terminalFilter === ALL_TERMINALS_VALUE
      ? transactions
      : transactions.filter(
          (txn) => String(txn.terminalID) === terminalFilter,
        );

  if (!scoped.length) return [];

  const merchantName = responseData?.acquirer?.merchantName || "N/A";
  const merchantStore = responseData?.acquirer?.merchantStore || "N/A";
  const currencyCode = responseData?.fiat?.currencyCode || "N/A";

  return scoped.map((txn) => ({
    "Merchant Name": merchantName,
    "Merchant Store": merchantStore,
    "Currency Code": currencyCode,
    "Terminal ID": txn.terminalID || "N/A",
    Transaction: txn.acquirer?.transactionID || "N/A",
    [withTz("QR Datetime")]: formatDateTime(txn?.createdAt),
    Amount: parseFloat(txn.transactionAmount || 0).toFixed(2),
    Currency: txn.crypto?.currencySymbol || "N/A",
    Exchange:
      txn.crypto?.exchangeName || txn.crypto?.exchangeID || "N/A",
    [withTz("Update Datetime")]: formatDateTime(txn?.updatedAt),
    Status: txn.blokko?.transactionStatus || "N/A",
  }));
}

export function writeTransactionSearchExcel(rows) {
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Transactions");
  XLSX.writeFile(wb, "Transaction_Report.xlsx");
}
